/* Cart offers (cart drawer + cart page)
   1. Coupon box          - the code is carried to checkout as /checkout?discount=CODE
   2. Prepaid (UPI) offer - "Pay online, extra X% off" + saving shown; optional one-tap code
   3. WhatsApp number     - worldwide (country selector + E.164), saved on the cart (attributes whatsapp_number / whatsapp_optin) and pre-filled
                            as the checkout phone, so abandoned checkouts carry the number and a
                            WhatsApp tool (Interakt, WATI, AiSensy, Zoko...) can send the reminders.
   Nothing here can send a WhatsApp message or give a payment-method discount by itself:
   that part is done in Shopify / the WhatsApp tool (see the setup notes). */
(function () {
  if (window.__nvCo) return;
  window.__nvCo = true;

  var cfg = window.nvCartOffers || {};
  var CK = 'nv_coupon_v1', PK = 'nv_wa_v1';

  function root() { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function jget(k) { try { var o = JSON.parse(localStorage.getItem(k) || 'null'); return o && typeof o === 'object' ? o : null; } catch (e) { return null; } }
  function jset(k, o) { try { if (o) localStorage.setItem(k, JSON.stringify(o)); else localStorage.removeItem(k); } catch (e) { /* private mode */ } }
  function toast(h) { if (window.NvCore && NvCore.toast) NvCore.toast(h); }
  function money(paise) {
    if (window.NvCore && NvCore.money) return NvCore.money(paise);
    return 'Rs. ' + (paise / 100).toFixed(0);
  }
  function post(url, body) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', url);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        var j = null; try { j = JSON.parse(x.responseText); } catch (e) { /* not json */ }
        if (x.status >= 200 && x.status < 300) resolve(j); else reject(j || {});
      };
      x.onerror = function () { reject({}); };
      x.send(JSON.stringify(body));
    });
  }


  /* ---------- worldwide phone numbers ---------- */
  var COUNTRIES = [
    ['IN','India','91'],['US','United States','1'],['CA','Canada','1'],['GB','United Kingdom','44'],['AE','United Arab Emirates','971'],
    ['AU','Australia','61'],['NZ','New Zealand','64'],['SG','Singapore','65'],['MY','Malaysia','60'],['SA','Saudi Arabia','966'],
    ['QA','Qatar','974'],['KW','Kuwait','965'],['OM','Oman','968'],['BH','Bahrain','973'],['NP','Nepal','977'],['LK','Sri Lanka','94'],
    ['BD','Bangladesh','880'],['PK','Pakistan','92'],['BT','Bhutan','975'],['MV','Maldives','960'],['DE','Germany','49'],['FR','France','33'],
    ['IT','Italy','39'],['ES','Spain','34'],['NL','Netherlands','31'],['BE','Belgium','32'],['CH','Switzerland','41'],['AT','Austria','43'],
    ['SE','Sweden','46'],['NO','Norway','47'],['DK','Denmark','45'],['FI','Finland','358'],['IE','Ireland','353'],['PT','Portugal','351'],
    ['PL','Poland','48'],['RU','Russia','7'],['TR','Turkey','90'],['IL','Israel','972'],['ZA','South Africa','27'],['KE','Kenya','254'],
    ['NG','Nigeria','234'],['MU','Mauritius','230'],['JP','Japan','81'],['KR','South Korea','82'],['CN','China','86'],['HK','Hong Kong','852'],
    ['TH','Thailand','66'],['ID','Indonesia','62'],['PH','Philippines','63'],['VN','Vietnam','84'],['BR','Brazil','55'],['MX','Mexico','52'],
    ['AR','Argentina','54'],['TT','Trinidad and Tobago','1868'],['GY','Guyana','592'],['FJ','Fiji','679']
  ];
  var DIALS = {}; COUNTRIES.forEach(function (c) { DIALS[c[2]] = 1; });
  function guessISO() {
    var iso = (window.Shopify && Shopify.country) || '';
    if (!iso) { var l = (navigator.language || '').split('-')[1]; iso = l || ''; }
    iso = String(iso).toUpperCase();
    return COUNTRIES.some(function (c) { return c[0] === iso; }) ? iso : 'IN';
  }
  function dialOf(iso) { for (var i = 0; i < COUNTRIES.length; i++) if (COUNTRIES[i][0] === iso) return COUNTRIES[i][2]; return '91'; }
  // digits like '14155550123' -> { cc, num } using the longest known dial code
  function splitIntl(digits) {
    for (var n = 4; n >= 1; n--) { var cc = digits.slice(0, n); if (DIALS[cc] && digits.length - n >= 6) return { cc: cc, num: digits.slice(n) }; }
    return null;
  }
  function fullNum(w) { return '+' + (w.cc || '91') + w.num; }
  function prettyNum(w) { return '+' + (w.cc || '91') + ' ' + w.num; }
  function ccOptions(selIso) {
    return COUNTRIES.map(function (c) {
      return '<option value="' + c[0] + '"' + (c[0] === selIso ? ' selected' : '') + '>' + esc(c[1]) + ' (+' + c[2] + ')</option>';
    }).join('');
  }
  var pickIso = guessISO();

  /* ---------- state ---------- */
  var coupon = jget(CK);          // { code, kind: 'manual' | 'prepaid' }
  var wa = jget(PK);              // { cc: '91', num: '9876543210' }  (cc missing on old saves = India)
  var cart = null, lastFetch = 0, fetchTimer = null, attrSynced = '';
  var msg = { cp: '', wa: '' };

  function pct() { var v = Number(cfg.prepaidPercent); return Math.max(0, isNaN(v) || cfg.prepaidPercent == null ? 5 : v); }

  /* ---------- cart data (throttled) ---------- */
  function loadCart() {
    lastFetch = Date.now();
    return fetch(root() + 'cart.js?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var changed = !cart || cart.total_price !== c.total_price || cart.item_count !== c.item_count;
        cart = c;
        syncAttributes();
        if (!wa && c.attributes && c.attributes.whatsapp_number) {
          var d = String(c.attributes.whatsapp_number).replace(/\D/g, '');
          var sp = splitIntl(d);
          if (sp) { wa = sp; jset(PK, wa); changed = true; }
        }
        return changed;
      });
  }
  function scheduleLoad() {
    var wait = Math.max(0, 1200 - (Date.now() - lastFetch));
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () { loadCart().then(function (ch) { if (ch) render(true); }).catch(function () {}); }, wait);
  }
  // keep the number on the cart (a new cart loses attributes)
  function syncAttributes() {
    if (!wa || !cart || cart.item_count < 1) return;
    var want = fullNum(wa);
    var key = cart.token + '|' + want;
    if ((cart.attributes && cart.attributes.whatsapp_number === want) || attrSynced === key) return;
    attrSynced = key;
    post(root() + 'cart/update.js', { attributes: { whatsapp_number: want, whatsapp_optin: 'yes' } }).catch(function () { attrSynced = ''; });
  }


  /* ---------- html ---------- */
  function prepaidHTML() {
    if (cfg.prepaid === false || !pct() || !cart || cart.total_price < 1) return '';
    var save = Math.round(cart.total_price * pct() / 100);
    var text = String(cfg.prepaidText || 'Pay by UPI / Card and get an extra [percent]% off')
      .replace(/\[percent\]|\{percent\}/g, pct()).replace(/\[amount\]|\{amount\}/g, money(save));
    var on = coupon && coupon.kind === 'prepaid';
    return '<div class="nv-co__box nv-co__pre' + (on ? ' is-on' : '') + '">' +
      '<div class="nv-co__t"><b>' + esc(text) + '</b><small>You will save about ' + esc(money(save)) + '</small></div>' +
      (cfg.prepaidCode
        ? (on ? '<button type="button" class="nv-co__btn nv-co__btn--ghost" data-co="pre-off">Remove</button>'
              : '<button type="button" class="nv-co__btn" data-co="pre-on">Apply</button>')
        : '') +
      '</div>';
  }
  function couponHTML() {
    if (cfg.coupon === false) return '';
    if (coupon && coupon.kind === 'manual') {
      return '<div class="nv-co__box nv-co__cp is-on"><div class="nv-co__t"><b>Coupon ' + esc(coupon.code) + ' saved</b>' +
        '<small>Applied at checkout (validated there)</small></div>' +
        '<button type="button" class="nv-co__btn nv-co__btn--ghost" data-co="cp-off">Remove</button></div>';
    }
    return '<div class="nv-co__box nv-co__cp"><label class="nv-co__l" for="nv-co-code">Coupon code</label>' +
      '<div class="nv-co__row"><input id="nv-co-code" class="nv-co__in" type="text" autocomplete="off" autocapitalize="characters" maxlength="40" placeholder="Enter coupon code" data-co-in="cp">' +
      '<button type="button" class="nv-co__btn" data-co="cp-on">Apply</button></div>' +
      '<p class="nv-co__m" data-co-msg="cp">' + esc(msg.cp) + '</p></div>';
  }
  function waHTML() {
    if (cfg.wa === false) return '';
    if (wa) {
      return '<div class="nv-co__box nv-co__wa is-on"><div class="nv-co__t"><b>WhatsApp: ' + esc(prettyNum(wa)) + '</b>' +
        '<small>Order updates and offers will be sent to this number</small></div>' +
        '<button type="button" class="nv-co__btn nv-co__btn--ghost" data-co="wa-off">Change</button></div>';
    }
    return '<div class="nv-co__box nv-co__wa"><label class="nv-co__l" for="nv-co-wa">' + esc(cfg.waText || 'Get order updates and special offers on WhatsApp') + '</label>' +
      '<div class="nv-co__row nv-co__row--wa"><select class="nv-co__cc nv-co__sel" aria-label="Country code" data-co-cc>' + ccOptions(pickIso) + '</select><input id="nv-co-wa" class="nv-co__in" type="tel" inputmode="tel" autocomplete="tel-national" maxlength="20" placeholder="Mobile number" data-co-in="wa">' +
      '<button type="button" class="nv-co__btn" data-co="wa-on">Save</button></div>' +
      '<p class="nv-co__m" data-co-msg="wa">' + esc(msg.wa) + '</p>' +
      '<p class="nv-co__fine">By saving your number you agree to receive reminders and offers on WhatsApp. Reply STOP anytime to opt out.</p></div>';
  }

  /* ---------- mount ---------- */
  function hosts() {
    var out = [];
    var items = document.getElementById('CartDrawer-CartItems');
    if (items && !document.querySelector('cart-drawer.is-empty')) out.push(items);
    var page = document.querySelector('cart-items:not(cart-drawer-items) .page-width');
    if (page && !page.closest('.is-empty')) out.push(page);
    return out;
  }
  function render(force) {
    var hs = hosts();
    document.querySelectorAll('.nv-co').forEach(function (n) { if (hs.indexOf(n.parentElement) === -1 || !cart || cart.item_count < 1) n.remove(); });
    if (!cart || cart.item_count < 1) return;
    var sig = JSON.stringify([coupon, wa, cart.total_price, msg]);
    hs.forEach(function (h) {
      var n = h.querySelector(':scope > .nv-co');
      if (!n) {
        n = document.createElement('section');
        n.className = 'nv-co';
        n.setAttribute('aria-label', 'Offers');
        // The cart's own code treats every 'change' event inside the cart form as a quantity edit
        // (-> "There was an error while updating your cart"). Our inputs/select are not quantities, so keep
        // their events from reaching it. (Our own handlers listen on document in the capture phase, so they still run.)
        ['change', 'input'].forEach(function (ev) { n.addEventListener(ev, function (e) { e.stopPropagation(); }); });
        var saved = h.querySelector(':scope > .nv-saved');
        if (saved) h.insertBefore(n, saved); else h.appendChild(n);
        force = true;
      }
      if (force || n.getAttribute('data-sig') !== sig) {
        n.innerHTML = prepaidHTML() + couponHTML() + waHTML();
        n.setAttribute('data-sig', sig);
      }
    });
  }

  /* ---------- actions ---------- */
  function setCoupon(c) { coupon = c; jset(CK, c); }
  function findIn(btn, sel) { var box = btn.closest('.nv-co'); return box ? box.querySelector(sel) : null; }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-co]');
    if (!b) return;
    e.preventDefault();
    var act = b.getAttribute('data-co');
    if (act === 'pre-on') { setCoupon({ code: String(cfg.prepaidCode).toUpperCase(), kind: 'prepaid' }); msg.cp = ''; toast('UPI offer added &middot; applied at checkout'); render(true); }
    else if (act === 'pre-off' || act === 'cp-off') { setCoupon(null); msg.cp = ''; render(true); }
    else if (act === 'cp-on') {
      var inp = findIn(b, '[data-co-in="cp"]');
      var code = inp ? inp.value.trim() : '';
      if (!/^[A-Za-z0-9_\-]{2,40}$/.test(code)) { msg.cp = 'Enter a valid coupon code (letters and numbers only).'; render(true); return; }
      setCoupon({ code: code.toUpperCase(), kind: 'manual' }); msg.cp = '';
      toast('Coupon saved &middot; applied at checkout');
      render(true);
    } else if (act === 'wa-off') { wa = null; jset(PK, null); msg.wa = ''; render(true); }
    else if (act === 'wa-on') {
      var wi = findIn(b, '[data-co-in="wa"]');
      var raw = (wi ? wi.value : '').trim();
      var sel = findIn(b, '[data-co-cc]');
      var cc = dialOf(sel ? sel.value : pickIso), n = '';
      if (raw.charAt(0) === '+' || raw.slice(0, 2) === '00') {           // typed in full international format
        var sp = splitIntl(raw.replace(/\D/g, '').replace(/^00/, ''));
        if (sp) { cc = sp.cc; n = sp.num; }
      } else {
        n = raw.replace(/\D/g, '').replace(/^0+/, '');                   // drop a leading trunk 0
      }
      if (n.length < 6 || n.length > 14 || (cc + n).length > 15) { msg.wa = 'Please enter a valid mobile number with the correct country.'; render(true); return; }
      b.disabled = true;
      post(root() + 'cart/update.js', { attributes: { whatsapp_number: '+' + cc + n, whatsapp_optin: 'yes' } }).then(function () {
        wa = { cc: cc, num: n }; jset(PK, wa); msg.wa = ''; attrSynced = cart ? cart.token + '|+' + cc + n : '';
        toast('WhatsApp number saved'); render(true);
      }).catch(function () { b.disabled = false; msg.wa = 'Could not save. Please try again.'; render(true); });
    }
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-co-cc]');
    if (sel) pickIso = sel.value;
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest && e.target.closest('[data-co-in]');
    if (!inp) return;
    e.preventDefault();
    var btn = findIn(inp, inp.getAttribute('data-co-in') === 'cp' ? '[data-co="cp-on"]' : '[data-co="wa-on"]');
    if (btn) btn.click();
  }, true);

  // Checkout button: carry the coupon + phone to checkout
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="checkout"], button#checkout, #CartDrawer-Checkout');
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    var q = [];
    if (coupon && coupon.code) q.push('discount=' + encodeURIComponent(coupon.code));
    if (wa && wa.num) q.push('checkout%5Bshipping_address%5D%5Bphone%5D=' + encodeURIComponent(fullNum(wa)));
    if (!q.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = root() + 'checkout?' + q.join('&');
  }, true);

  /* ---------- keep it in sync with cart redraws ---------- */
  function scan() {
    if (!hosts().length) return;
    if (!cart) { loadCart().then(function () { render(true); }).catch(function () {}); return; }
    render(false);
    scheduleLoad();
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(scan, 150); }
  function boot() {
    scan();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', function () { cart = null; later(); });
    window.addEventListener('pageshow', function () { cart = null; later(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
